import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { APICreateResponse, APIListResponse, APIUpdateResponse } from "@shared/api-client-services/api-responses.interface";
import { map } from "rxjs";
import { ConfigService } from "@shared/services/core/config.service";
import { PaymentGateway, PaymentGatewayPublicCredentials, StoredAccountCreationStandard } from "./rentals-core-standard.client.interface";

@Injectable({ providedIn: 'root' })
export class RentalsCoreStandardClientService {
    private http = inject(HttpClient);
    private env = inject(ConfigService);

    getGateways() {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/core/payment/gateway`;

        return this.http.get<APIListResponse<PaymentGateway>>(url).pipe(map(response => response.items));
    }

    getGatewayById(gatewayId: number) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/core/payment/gateway/${gatewayId}`;

        return this.http.get<PaymentGateway>(url);
    }

    createStoredAccount(data: StoredAccountCreationStandard) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/core/payment/stored-account`;

        return this.http.post<APICreateResponse<any>>(url, data);
    }

    updateStoredAccount(intentId: string, paymentMethodId: any) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/core/payment/stored-account`;

        const params = { intentId };
        const body = { paymentMethodId };
        const options = { params };

        return this.http.put<APIUpdateResponse<any>>(url, body, options);
    }

    getGatewayPublicKeyById(gatewayId: number) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/core/payment/gateway/${gatewayId}/public-credentials`;

        return this.http.get<PaymentGatewayPublicCredentials>(url);
    }
}